import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=28905c70&scoped=true"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=28905c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28905c70",
  null
  
)

export default component.exports